
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Neev Employee Sports Meet 2026</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm kite-festival section-banner-bg-1">
    <div class="container">
            <h5>NEEV Newfangled Entertainment Energy and Value!!</h5>
            <h5>22<sup>th</sup> Employee Annual Sports & Cultural Meet
                15<sup>rd</sup>, 16<sup>th</sup> and 17<sup>th</sup>January 2026</h5>
        <div class="row mt-4 text-justify">
            <!-- <div class="col-md-4">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev.avif"
                        alt="neev" class="w-100">
                </div>
            </div> -->

            <div class="col-md-12">
                <div class="widget_title inner-title">
                    <h4>INTRODUCTION OF THE CONCEPT:</h4>
                </div>
                <div class="fide-chess-text">
                    <p> Every year in the month of January, a 3-day Annual sports event is organized for the
                        employees where all teaching and non-teaching staff does participate in the sports. It is also
                        one of many such events organized by RGI.</p>
                    <div class="widget_title inner-title">
                        <h4>EXISTING SCENARIO:</h4>
                    </div>

                    <p>
                        Every year the meet is organized where participation of employees takes place.
                    </p>
                    <div class="widget_title inner-title">
                        <h4>REASON BEHIND STARTING THE CONCEPT:</h4>
                    </div>
                    <p>Annual sports meet is one of the opportunities that bring RGI family together.</p>
                </div>
            </div>
            <div class="col-md-12 mt-3">


                <div class="widget_title inner-title">
                    <h4>VISION OR GOAL OF THIS CONCEPT:</h4>
                </div>
                <p>It is an effort to build interpersonal relationships among employees, promote
                    companionship, commitment, and teamwork.</p>
                    <div class="widget_title inner-title">
                        <h4>OBJECTIVES OF THE CONCEPT:</h4>
                    </div>

                    <ul class="list-style list-style1">
                        <li>To provide rejuvenation to the employees.</li>
                        <li>Encouragement to their sports interest.</li>
                        <li>To bridge the gap between various authorities.</li>
                    </ul>
                    <div class="widget_title inner-title">
                        <h4>GENERAL RULES AND REGULATIONS TO BE FOLLOWED STRICTLY:</h4>
                    </div>
                    <ul class="list-style list-style1">
                        <li>Spot Entry not allowed in any case</li>
                        <li>Those who have registered through online form submission, they only can participate in the events</li>
                        <li>
                            <strong>Please find the Forms under</strong> :
                            <ul class="column-count">
                                <li><a href="https://forms.gle/ci51WjgqfDfcbBVBA" target="_blank">🎾Badminton </a></li>
                                <li><a href="https://forms.gle/gexP6FnGrqe66Mnf9" target="_blank">♟️ Chess </a></li>
                                <li><a href="https://forms.gle/ETkhQ73q1g7NbDkS6" target="_blank">👑 Carom </a></li>
                                <li><a href="https://forms.gle/XuL2uaPySckTHhYC6" target="_blank">🎱 Pool Table </a></li>
                                <li><a href="https://forms.gle/BetzsUh6CGjv1A387" target="_blank">🏓 Table Tennis </a></li>
                                <li><a href="https://forms.gle/JVqChxRkesfKResy5" target="_blank">🪑 Musical Chair </a></li>
                                <li><a href="https://forms.gle/xFjkc3A9RaB2jz6J7" target="_blank">🎙 Solo Singing </a></li>
                                <li><a href="https://forms.gle/jWRUp29uQ38xNtkE6" target="_blank">💃 Solo Dance </a></li>
                                <li><a href="https://forms.gle/Tr1ja9GkwjaUjGeL8" target="_blank">✍ Writing </a></li>
                            </ul>
                        </li>
                    </ul>
            </div>
        </div>
        <div class="row mt-5 justify-content-between">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>PHOTOS</h4>
                </div>
            </div>
            <div class="col-auto">
                   <a routerLink="/photogallery" class="cmn-button">View More</a>
            </div>
        </div>
             <div class="lightBox--gallery">
                      <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>

                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp"
                          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp">
                          <a href="Javascript:void(0);">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp"
                                  alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                              <div class="light-gallery-poster">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                              </div>
                          </a>
                      </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                    
                      </ul>
                   
                    </div>
    </div>
</section>

